var React = require('react');

function RexMyRecord (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"rex-my-record"),React.createElement("path",{"fill":"#999","d":"M16 32c-8.837 0-16-7.163-16-16s7.163-16 16-16c8.837 0 16 7.163 16 16s-7.163 16-16 16zM20.117 17.854h-8.278c-1.338 0.006-2.421 1.090-2.427 2.427v1.998h13.176v-1.998c-0.043-1.339-1.131-2.409-2.471-2.427zM16 16.030c2.347 0 4.25-1.903 4.25-4.251s-1.903-4.25-4.25-4.25c-2.347 0-4.251 1.903-4.251 4.25 0.006 2.345 1.905 4.245 4.251 4.251z","key":1})]);
}

RexMyRecord.defaultProps = {"version":"1.1","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = RexMyRecord;

RexMyRecord.default = RexMyRecord;
